import UserAvatar from '../../User/UserAvatar'

const AuthorCell = () => {
  return ({ created_by }) => {
    const { name, profile_url } = created_by
    const user = { ...created_by, url: profile_url }

    return (
      <div className='articles-overview__table-author'>
        <UserAvatar user={user} openInNewTab style={{ width: '16px', height: '16px' }} />
        <a href={user.url} target='_blank'>{name}</a>
      </div>
    )
  }
}

export default AuthorCell
